import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex border-r flex-col xl:flex-row pt-4 xl:pt-0" }
const _hoisted_2 = { class: "xl:hidden md:px-8 px-4" }
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { class: "bg-white hidden overflow-y-auto h-auto xl:block w-[250px] pb-32" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex justify-center mt-4 mb-48" }

import { Report, ReportPlotType } from "@/types/Report";
import AddReportMenu from "@/views/reports/components/AddReportMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSidebar',
  props: {
    reports: {},
    selectedReport: {}
  },
  emits: ["selectReport", "createReport"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const switchToReport = (report: Report) => {
  if (report && report._id !== props.selectedReport?._id) {
    emit("selectReport", report);
  }
};

const handleSelectChange = (event: Event) => {
  const reportId = (event.target as HTMLInputElement).value;
  const report = props.reports.find((f) => f._id === reportId);
  if (report) {
    switchToReport(report);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        class: "w-auto oai-inputs",
        onChange: handleSelectChange
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
          return (_openBlock(), _createElementBlock("option", {
            key: report.name,
            value: report._id,
            selected: _ctx.selectedReport?._id === report._id
          }, _toDisplayString(report.name), 9, _hoisted_3))
        }), 128))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([_ctx.selectedReport?._id === report._id && 'border-l-yellow text-oaiGray-900 bg-gray-50', "px-5 md:px-8 py-2 lg:p-5 border-l-4 cursor-pointer border-b hover:text-oaiGray-900 text-gray-600 font-medium text-xs flex items-center justify-between break-words"]),
          key: report.name,
          onClick: ($event: any) => (switchToReport(report))
        }, _toDisplayString(report.name), 11, _hoisted_5))
      }), 128)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(AddReportMenu, {
          onCreateReport: _cache[0] || (_cache[0] = ($event: any) => (emit('createReport', $event)))
        })
      ])
    ])
  ]))
}
}

})